import { ArrowDown2 } from "iconsax-reactjs"
import { useEffect, useMemo, useState } from "react"
import { useForm } from "react-hook-form"

import { TabTag } from "@/components/shared"
import { useAffiliateCategories } from "@/modules/helpers/hooks"
import { cn } from "@/modules/helpers/hooks/shared/utils"
import { sendHaptic } from "@/modules/helpers/utils"

interface CategoryFilterProps {
  value: string
  onChange: (category: string | null) => void
}

interface CategoryForm {
  category: string
}

export function CategoryFilter({ value, onChange }: CategoryFilterProps) {
  const { data: affiliateCategories } = useAffiliateCategories()
  const categories = affiliateCategories?.data?.data || []

  const form = useForm<CategoryForm>({
    defaultValues: {
      category: value || ""
    }
  })

  const selectedCategory = form.watch("category")
  const [isExpanded, setIsExpanded] = useState(false)

  const displayLabel = useMemo(() => {
    if (!selectedCategory) return "Tất cả"
    return selectedCategory
  }, [selectedCategory])

  const handleCategorySelect = (category: string | null) => {
    const categoryValue = category || ""
    form.setValue("category", categoryValue)
    onChange(category)
    sendHaptic()
  }

  // Sync form value when prop changes
  useEffect(() => {
    form.setValue("category", value || "")
  }, [value, form])

  return (
    <div className="gap-2 px-2 flex flex-col py-2">
      <p className="text-sm font-medium text-primary-800">Danh mục</p>
      <div
        onClick={() => {
          setIsExpanded(!isExpanded)
          sendHaptic()
        }}
        className="rounded-xl transition-all ease-in-out h-12 border flex items-center px-2 justify-between cursor-pointer"
      >
        <span className="bg-[#E9F3F6] !text-xss text-primary-800 p-1 h-fit rounded-sm px-2 capitalize">
          {displayLabel}
        </span>
        <div className={cn("transition-transform", isExpanded && "rotate-180")}>
          <ArrowDown2 size={16} color="#045664" />
        </div>
      </div>

      {isExpanded && (
        <div className="flex flex-wrap gap-2 mt-2 bg-background p-3 rounded-xl">
          {/* Tất cả option */}
          <TabTag
            label={"Tất cả"}
            className="bg-white"
            active={!selectedCategory}
            onClick={() => handleCategorySelect(null)}
          ></TabTag>

          {/* Category options */}
          {categories.map((category) => (
            <TabTag
              key={category}
              className="bg-white"
              label={category}
              active={selectedCategory === category}
              onClick={() => handleCategorySelect(category)}
            ></TabTag>
          ))}
        </div>
      )}
    </div>
  )
}
